import React from 'react'
import {
  FacebookShareButton,
  TwitterShareButton,
  EmailShareButton,
  RedditShareButton
} from "react-share"
import './socialShare.css'

const BlogSocialShare = ({ slug, title }) => (
  <div className="social-sharing-blog">
    <FacebookShareButton
      url={"https://www.twistedroad.com/blog/posts/" + slug}
      quote={title}
      className="is-inline-block"
    ><span className="icon">
      <i className="fab fa-facebook-f"></i></span>
    </FacebookShareButton>
    <TwitterShareButton
      url={"https://www.twistedroad.com/blog/posts/" + slug}
      title={title}
    ><span className="icon">
      <i className="fab fa-twitter"></i></span>
    </TwitterShareButton>
    <RedditShareButton
      url={"https://www.twistedroad.com/blog/posts/" + slug}
      title={title}
      windowWidth={660}
      windowHeight={460}
    ><span className="icon">
        <i className="fab fa-reddit"></i>
        </span>
    </RedditShareButton>
    <EmailShareButton
      url={"https://www.twistedroad.com/blog/posts/" + slug}
      title={title}
      body="Check out this article at Twisted Road!"
    >
      <span className="icon">
        <i className="fas fa-envelope"></i>
      </span>
    </EmailShareButton>
  </div>
)

export default BlogSocialShare


